const generateRandomKey = (range: number = 1000000) => Math.floor(Math.random() * range)

export default generateRandomKey;